module.exports = __webpack_public_path__ + "static/app-store-badge-2928664fe1fc6aca88583a6f606d60ba.svg";